const $ = require('jquery');
const util = require('../utils/util');
const Dialog = require('../lib/dialog').default;

const tabbyInfoFlyin = {
    /**
     * Tabby PDP modal dialog
     */
    init: () => {
        $('.tabby-pay-info, .tabby-image').on('click keypress', function (e) {
            if (util.isClickOrSpaceOrEnter(e)) {
                const dialog = new Dialog({
                    additionalClasses: ['tabby-info-overlay'],
                    useLegacyBackdrop: false,
                    html: $('.tabbyInfoContent').html(),
                    isModal: true,
                    useLegacyContainer: true,
                    /**
                     * Modal call backs in/out
                     */
                    callback: () => {
                        $('.ui-dialog-content').removeAttr('style');
                        $('.ui-dialog').css('top', '100px');
                        $('body').addClass('ui-dialog-position-fixed');
                        document.activeElement.blur();

                        $('.tabby-info-overlay .ocd-close').on('keypress', function (event) {
                            if (util.isClickOrSpaceOrEnter(event)) {
                                dialog.close();
                            }
                        });

                        $('.tabby-info-overlay .close').on('click', function () {
                            dialog.close();
                        });
                    },
                    /**
                     *
                     */
                    closeCallback: () => {
                        $('body').removeClass('ui-dialog-position-fixed');
                        document.activeElement.blur();
                    }
                });
                dialog.open();
            }
        });
    }
};

exports.init = tabbyInfoFlyin.init;
